// extracted by mini-css-extract-plugin
export default {"container":"UserMessage-module__container--qQMdD","mention":"UserMessage-module__mention--iKJnY"};